import { type BreakdownOption, BREAKDOWNS } from 'features/charts-v2/types'
import type { CustomBreakdown as CustomBreakdownV2 } from 'features/charts-v2/types/filter-hash/v2'

/**
 * Entry in the selected breakdowns list - can be either standard or custom
 */
export interface SelectedBreakdownEntry {
  /** Unique ID for the entry (breakdown ID for standard, or generated ID for custom) */
  id: string
  /** Standard breakdown option (if this is a standard breakdown) */
  standard?: BreakdownOption
  /** Custom breakdown (if this is a custom field breakdown) */
  custom?: CustomBreakdownV2
}

/**
 * Helper to create a unique ID for a custom breakdown
 */
export function getCustomBreakdownId(cb: CustomBreakdownV2): string {
  return `custom:${cb.model}:${cb.field}`
}

/**
 * Helper to get display label for a breakdown entry
 */
export function getBreakdownEntryLabel(entry: SelectedBreakdownEntry): string {
  if (entry.standard) {
    const config = Object.values(BREAKDOWNS).find(
      (b) => b.id === entry.standard,
    )
    return config?.label || entry.standard
  }
  if (entry.custom) {
    return entry.custom.alias
  }
  return entry.id
}
